import React from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import { theme } from '../styles/theme';
import Layout from '../components/layout/Layout';
import FaqAccordion, { FaqAccordionItem } from '../components/FaqAccordion';

const FAQ_ITEMS: FaqAccordionItem[] = [
  {
    question: 'Hvordan logger jeg inn eller oppretter konto?',
    answer: (
      <>
        <p>
          Vi bruker nå innlogging via Shopify. Trykk på{' '}
          <strong>«Logg inn med Shopify»</strong>, og logg inn – eller opprett en
          konto – med e-postadressen din. Du trenger ikke lenger et eget passord
          hos oss.
        </p>
        <p>
          Med en konto ser du ordrehistorikken din og kan bruke butikkreditt.
        </p>
      </>
    ),
  },
  {
    question: 'Hvordan bruker jeg butikkreditten min?',
    answer: (
      <>
        <p>
          Butikkreditten din ligger nå på Shopify-kontoen din og kan brukes
          direkte i nettbutikken vår. Logg inn med samme konto når du handler på{' '}
          <a href="https://tryllepapp.no" target="_blank" rel="noopener noreferrer">
            tryllepapp.no
          </a>
          , så kan du betale med butikkreditten ved utsjekk.
        </p>
        <p>
          Du trenger ikke lenger kontakte oss for å bruke kreditten – den trekkes
          automatisk fra i kassen.
        </p>
      </>
    ),
  },
  {
    question: 'Kan jeg selge kort uten å logge inn?',
    answer: (
      <p>
        Ja. Du kan sende inn en salgsliste som gjest og få betalt via
        bankoverføring. Men for å få betalt i <strong>butikkreditt</strong> må du
        logge inn med Shopify-kontoen din når du sender inn lista, slik at
        kreditten legges til kontoen din.
      </p>
    ),
  },
];

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: ${theme.colors.text};
  margin-bottom: 2rem;
  text-align: center;
`;

const FaqPage: React.FC = () => {
  return (
    <Layout>
      <Helmet>
        <title>Ofte stilte spørsmål | Tryllepapp</title>
        <meta name="description" content="Svar på vanlige spørsmål om å selge Magic: The Gathering-kort, store credit og bruk av Tryllepapp." />
        <link rel="canonical" href="https://selg.tryllepapp.no/faq" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'Hvordan logger jeg inn eller oppretter konto?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Vi bruker nå innlogging via Shopify. Trykk på «Logg inn med Shopify», og logg inn – eller opprett en konto – med e-postadressen din. Du trenger ikke lenger et eget passord hos oss. Med en konto ser du ordrehistorikken din og kan bruke butikkreditt.',
                },
              },
              {
                '@type': 'Question',
                name: 'Hvordan bruker jeg butikkreditten min?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Butikkreditten din ligger nå på Shopify-kontoen din og kan brukes direkte i nettbutikken vår på tryllepapp.no. Logg inn med samme konto når du handler, så kan du betale med butikkreditten ved utsjekk. Du trenger ikke lenger kontakte oss for å bruke kreditten.',
                },
              },
              {
                '@type': 'Question',
                name: 'Kan jeg selge kort uten å logge inn?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Ja. Du kan sende inn en salgsliste som gjest og få betalt via bankoverføring. For å få betalt i butikkreditt må du logge inn med Shopify-kontoen din når du sender inn lista, slik at kreditten legges til kontoen din.',
                },
              },
            ],
          })}
        </script>
      </Helmet>
      <Container>
        <Title>Ofte stilte spørsmål</Title>
        <FaqAccordion items={FAQ_ITEMS} />
      </Container>
    </Layout>
  );
};

export default FaqPage;
